import { render, staticRenderFns } from "./trafficr.vue?vue&type=template&id=2e357171&scoped=true&"
import script from "./trafficr.vue?vue&type=script&lang=js&"
export * from "./trafficr.vue?vue&type=script&lang=js&"
import style0 from "./trafficr.vue?vue&type=style&index=0&id=2e357171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e357171",
  null
  
)

export default component.exports